import * as React from 'react';

import {scopeTranslationsReady} from 'common/i18n';

import {GlobalLoader} from './global-loader';

export const lazy = <T extends React.ComponentType<any>>(
  dynamicImport: () => Promise<{default: T}>,
  key?: React.Key,
) => (
  <React.Suspense fallback={<GlobalLoader />}>
    {React.createElement(
      React.lazy<React.ComponentType<{key?: React.Key}>>(() =>
        // keep the loader up until the chunk's translations arrive, so a non-English route never renders English first
        dynamicImport().then(async (module) => {
          await scopeTranslationsReady();
          return module;
        }),
      ),
      {key},
    )}
  </React.Suspense>
);
